import { useEffect, useMemo, useState } from "react";
import { useTextos } from "../context/useTextos";
import { useWorkshop } from "../context/useWorkshop";
import { checklistService } from "../services/checklistService";
import { CHECKLIST_STATUS } from "../lib/checklistTemplate";
import { contarCriticosChecklist } from "../lib/criterios";
import StatusBadge from "../components/StatusBadge";

const LOCALE_POR_IDIOMA = { pt: "pt-BR", en: "en-US", es: "es-ES" };

function isMesAtual(dataIso) {
  const d = new Date(dataIso);
  const hoje = new Date();
  return d.getMonth() === hoje.getMonth() && d.getFullYear() === hoje.getFullYear();
}

export default function DashboardPage({ onAbrirChecklist, onNovoChecklist }) {
  const { t, i18n } = useTextos();
  const localeAtual = LOCALE_POR_IDIOMA[i18n.language] || "pt-BR";
  const { workshopId } = useWorkshop();
  const [checklists, setChecklists] = useState([]);
  useEffect(() => {
    checklistService.list(workshopId).then(setChecklists);
  }, [workshopId]);

  const stats = useMemo(() => {
    const doMes = checklists.filter((c) => isMesAtual(c.createdAt));
    const aprovados = checklists.filter((c) => c.status === CHECKLIST_STATUS.APROVADO);
    const pendentes = checklists.filter((c) => c.status === CHECKLIST_STATUS.RASCUNHO);
    const itensCriticos = checklists.reduce((total, c) => total + contarCriticosChecklist(c), 0);
    return {
      doMes: doMes.length,
      aprovados: aprovados.length,
      pendentes: pendentes.length,
      itensCriticos,
    };
  }, [checklists]);

  const recentes = checklists.slice(0, 5);

  return (
    <div className="page">
      <header className="page__header">
        <h2>{t("checklist.dash_titulo")}</h2>
      </header>

      <div className="kpi-grid">
        <div className="kpi-card">
          <span className="kpi-card__label">{t("checklist.dash_kpi_mes")}</span>
          <span className="kpi-card__value">{stats.doMes}</span>
        </div>
        <div className="kpi-card">
          <span className="kpi-card__label">{t("checklist.dash_kpi_aprovados")}</span>
          <span className="kpi-card__value">{stats.aprovados}</span>
        </div>
        <div className="kpi-card">
          <span className="kpi-card__label">{t("checklist.dash_kpi_pendentes")}</span>
          <span className="kpi-card__value">{stats.pendentes}</span>
        </div>
        <div className="kpi-card kpi-card--critico">
          <span className="kpi-card__label">{t("checklist.dash_kpi_criticos")}</span>
          <span className="kpi-card__value">{stats.itensCriticos}</span>
        </div>
      </div>

      <section className="form-section">
        <h3>{t("checklist.dash_recentes_titulo")}</h3>
        {recentes.length === 0 ? (
          <p className="empty-state">{t("checklist.dash_nenhum")}</p>
        ) : (
          <div className="table-scroll">
            <table className="checklist-table">
            <thead>
              <tr>
                <th>{t("checklist.col_data")}</th>
                <th>{t("checklist.col_cliente")}</th>
                <th>{t("checklist.col_veiculo")}</th>
                <th>{t("checklist.col_status")}</th>
              </tr>
            </thead>
            <tbody>
              {recentes.map((c) => (
                <tr key={c.id} className="checklist-table__row" onClick={() => onAbrirChecklist(c.id)}>
                  <td>{new Date(c.updatedAt).toLocaleDateString(localeAtual)}</td>
                  <td>{c.cliente.nome || "—"}</td>
                  <td>
                    {c.veiculo.marca} {c.veiculo.modelo}
                  </td>
                  <td>
                    <StatusBadge status={c.status} kind="checklist" />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        )}
      </section>
    </div>
  );
}
